import { ArrowUpDropCircleIcon } from './ArrowUpDropCircleIcon';

/**
 * author: Austin Andrews
 * id 73B211DB-05CF-4025-B035-AD03454C47A6
 * name arrow-up-drop-circle
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-up-drop-circle.svg
 * tags
 * - Arrow 
 */
export const ArrowTopDropCircleIcon = ArrowUpDropCircleIcon;
export default ArrowTopDropCircleIcon